import styled from 'styled-components'

const FilterButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
`

export default FilterButtonRow
